/* generated using openapi-typescript-codegen -- do not edit */
/* istanbul ignore file */
/* tslint:disable */
/* eslint-disable */
import type { CreateWorkflowWithLinksRequest } from '../models/CreateWorkflowWithLinksRequest';
import type { Entity } from '../models/Entity';
import type { FormResponse } from '../models/FormResponse';
import type { LinkedEntityDto } from '../models/LinkedEntityDto';
import type { LinkedWorkflowSummaryDto } from '../models/LinkedWorkflowSummaryDto';
import type { LinkEntityToWorkflowRequest } from '../models/LinkEntityToWorkflowRequest';
import type { PeopleMigrationResultDto } from '../models/PeopleMigrationResultDto';
import type { Workflow } from '../models/Workflow';
import type { WorkflowContentDto } from '../models/WorkflowContentDto';
import type { WorkflowDto } from '../models/WorkflowDto';
import type { WorkflowsDto } from '../models/WorkflowsDto';
import type { CancelablePromise } from '../core/CancelablePromise';
import type { BaseHttpRequest } from '../core/BaseHttpRequest';
export class WorkflowInstanceService {
    constructor(public readonly httpRequest: BaseHttpRequest) {}
    /**
     * Get all workflows for a particular type of workflow from the DB.
     * @param orgGuid
     * @param workflowDefinitionGuid The workflow definition GUID. (optional)
     * @param includeArchived
     * @returns WorkflowsDto OK
     * @throws ApiError
     */
    public getWorkflowDtos(
        orgGuid: string,
        workflowDefinitionGuid: string,
        includeArchived: boolean = false,
    ): CancelablePromise<WorkflowsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowInstance/{orgGuid}/{workflowDefinitionGuid}/{includeArchived}/GetWorkflowDtos',
            path: {
                'orgGuid': orgGuid,
                'workflowDefinitionGuid': workflowDefinitionGuid,
                'includeArchived': includeArchived,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all workflows for a particular type of workflow from the DB.
     * @param orgGuid
     * @param workflowDefinitionGuid The workflow definition GUID. (optional)
     * @param entityGuid The entity GUID. For Guest users, their entity GUID will always be used, ignoring this.
     * @param includeArchived
     * @returns WorkflowsDto OK
     * @throws ApiError
     */
    public getWorkflowDtosForEntity(
        orgGuid: string,
        workflowDefinitionGuid: string,
        entityGuid: string,
        includeArchived: boolean = false,
    ): CancelablePromise<WorkflowsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowInstance/{orgGuid}/{workflowDefinitionGuid}/{includeArchived}/{entityGuid}/GetWorkflowDtos',
            path: {
                'orgGuid': orgGuid,
                'workflowDefinitionGuid': workflowDefinitionGuid,
                'entityGuid': entityGuid,
                'includeArchived': includeArchived,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Search contact activities with optional filters for entity and created-by user.
     * @param orgGuid The organization GUID.
     * @param workflowDefinitionGuid The workflow definition GUID for Contact Activities.
     * @param entityGuid Optional: filter by the contact/person entity GUID.
     * @param createdByUserGuid Optional: filter by the user who created the activity.
     * @param includeArchived Whether to include archived workflows.
     * @param housingApplicationSearch Optional: filter by linked housing application entity name (contains search).
     * @returns WorkflowsDto OK
     * @throws ApiError
     */
    public searchContactActivities(
        orgGuid: string,
        workflowDefinitionGuid: string,
        entityGuid?: string,
        createdByUserGuid?: string,
        includeArchived: boolean = false,
        housingApplicationSearch?: string,
    ): CancelablePromise<WorkflowsDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowInstance/{orgGuid}/{workflowDefinitionGuid}/SearchContactActivities',
            path: {
                'orgGuid': orgGuid,
                'workflowDefinitionGuid': workflowDefinitionGuid,
            },
            query: {
                'entityGuid': entityGuid,
                'createdByUserGuid': createdByUserGuid,
                'includeArchived': includeArchived,
                'housingApplicationSearch': housingApplicationSearch,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get a workflow instance by GUID.
     * @param workflowGuid The workflow GUID.
     * @param forPdf
     * @returns WorkflowContentDto OK
     * @throws ApiError
     */
    public getWorkflow(
        workflowGuid: string,
        forPdf?: string,
    ): CancelablePromise<WorkflowContentDto> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowInstance/{workflowGuid}/GetWorkflow',
            path: {
                'workflowGuid': workflowGuid,
            },
            query: {
                'forPdf': forPdf,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new workflow instance for a user.
     * @param workflowDefinitionGuid The workflow definition GUID.
     * @param entityGuid The entity GUID.
     * @param orgGuid The user GUID. Defaults to the current users GUID.
     * @param requestBody The name of this wf instance.
     * @returns WorkflowDto OK
     * @throws ApiError
     */
    public createWorkflowInstance(
        workflowDefinitionGuid: string,
        entityGuid: string,
        orgGuid: string,
        requestBody?: string,
    ): CancelablePromise<WorkflowDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowInstance/{workflowDefinitionGuid}/{entityGuid}/{orgGuid}/CreateWorkflowInstance',
            path: {
                'workflowDefinitionGuid': workflowDefinitionGuid,
                'entityGuid': entityGuid,
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new workflow instance for a user.
     * @param workflowDefinitionGuid The workflow definition GUID.
     * @param orgGuid The user GUID. Defaults to the current users GUID.
     * @param requestBody The name of this wf instance.
     * @returns WorkflowDto OK
     * @throws ApiError
     */
    public createWorkflowInstanceWithoutEntityGuid(
        workflowDefinitionGuid: string,
        orgGuid: string,
        requestBody?: string,
    ): CancelablePromise<WorkflowDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowInstance/{workflowDefinitionGuid}/{orgGuid}/CreateWorkflowInstanceWithoutEntityGuid',
            path: {
                'workflowDefinitionGuid': workflowDefinitionGuid,
                'orgGuid': orgGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a new workflow instance and optionally link additional entities in a single atomic operation.
     * @param requestBody The request containing workflow definition name, org, primary entity, and optional linked entities.
     * @returns WorkflowDto OK
     * @throws ApiError
     */
    public createWorkflowWithLinks(
        requestBody?: CreateWorkflowWithLinksRequest,
    ): CancelablePromise<WorkflowDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowInstance/CreateWorkflowWithLinks',
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create a form response on demand for a user-created form within an existing workflow.
     * Only works for forms that have `MetaInfo.UserCreated = true`.
     * @param workflowGuid
     * @param formDefinitionGuid
     * @returns FormResponse OK
     * @throws ApiError
     */
    public createFormResponseInWorkflow(
        workflowGuid: string,
        formDefinitionGuid: string,
    ): CancelablePromise<FormResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowInstance/{workflowGuid}/{formDefinitionGuid}/CreateFormResponseInWorkflow',
            path: {
                'workflowGuid': workflowGuid,
                'formDefinitionGuid': formDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete a user-created form response from a workflow.
     * Only works for form responses whose form definition has `MetaInfo.UserCreated = true`.
     * @param workflowGuid
     * @param formResponseGuid
     * @returns any OK
     * @throws ApiError
     */
    public deleteFormResponseInWorkflow(
        workflowGuid: string,
        formResponseGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/WorkflowInstance/{workflowGuid}/{formResponseGuid}/DeleteFormResponseInWorkflow',
            path: {
                'workflowGuid': workflowGuid,
                'formResponseGuid': formResponseGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Upgrades a form response to a newer version of the same form (same FormTemplateGuid) by
     * CREATING a new response on the target version and copying the prior response's answers into
     * it by QuestionCode. The original (source) response is kept intact — it stays in the workflow
     * as the read-only "original", still showing exactly the answers it captured. This is a
     * one-time copy (freeze): after the upgrade the two responses are independent, so editing the
     * new version never changes the original.
     *
     * The canonical shared-answer table is also seeded from the source (for intra-workflow
     * cross-form consistency); it is not used to carry answers into the new version — the direct
     * copy does that, keeping the original uncontaminated. Admin-gated (SetupBasic).
     * @param workflowGuid
     * @param formResponseGuid
     * @param targetFormDefinitionGuid
     * @returns FormResponse OK
     * @throws ApiError
     */
    public upgradeFormResponseVersion(
        workflowGuid: string,
        formResponseGuid: string,
        targetFormDefinitionGuid: string,
    ): CancelablePromise<FormResponse> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowInstance/{workflowGuid}/{formResponseGuid}/{targetFormDefinitionGuid}/UpgradeFormResponseVersion',
            path: {
                'workflowGuid': workflowGuid,
                'formResponseGuid': formResponseGuid,
                'targetFormDefinitionGuid': targetFormDefinitionGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Update a workflow instance.
     * @param workflowGuid The workflow GUID.
     * @param requestBody The updated workflow instance.
     * @returns WorkflowDto OK
     * @throws ApiError
     */
    public updateWorkflow(
        workflowGuid: string,
        requestBody?: Workflow,
    ): CancelablePromise<WorkflowDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/WorkflowInstance/{workflowGuid}/UpdateWorkflow',
            path: {
                'workflowGuid': workflowGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Triggers a workflow event using event code. For now, only sendEmail events
     * @param workflowGuid The workflow GUID.
     * @param eventCode
     * @returns any OK
     * @throws ApiError
     */
    public handleSendEmailEvent(
        workflowGuid: string,
        eventCode: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/WorkflowInstance/{workflowGuid}/{eventCode}/HandleSendEmailEvent',
            path: {
                'workflowGuid': workflowGuid,
                'eventCode': eventCode,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Triggers people migration for a workflow. Extracts person data from form responses
     * and creates Person + Entity records.
     * @param workflowGuid The workflow GUID.
     * @returns PeopleMigrationResultDto OK
     * @throws ApiError
     */
    public handleRunPeopleMigration(
        workflowGuid: string,
    ): CancelablePromise<PeopleMigrationResultDto> {
        return this.httpRequest.request({
            method: 'PUT',
            url: '/api/WorkflowInstance/{workflowGuid}/HandleRunPeopleMigration',
            path: {
                'workflowGuid': workflowGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all entities linked to a workflow.
     * @param workflowGuid The workflow GUID.
     * @returns LinkedEntityDto OK
     * @throws ApiError
     */
    public getLinkedEntities(
        workflowGuid: string,
    ): CancelablePromise<Array<LinkedEntityDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowInstance/{workflowGuid}/GetLinkedEntities',
            path: {
                'workflowGuid': workflowGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Link an entity to a workflow.
     * @param workflowGuid The workflow GUID.
     * @param requestBody The link request containing entity GUID and optional metadata.
     * @returns LinkedEntityDto OK
     * @throws ApiError
     */
    public linkEntityToWorkflow(
        workflowGuid: string,
        requestBody?: LinkEntityToWorkflowRequest,
    ): CancelablePromise<LinkedEntityDto> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowInstance/{workflowGuid}/LinkEntityToWorkflow',
            path: {
                'workflowGuid': workflowGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Unlink an entity from a workflow.
     * @param workflowGuid The workflow GUID.
     * @param entityGuid The entity GUID to unlink.
     * @returns any OK
     * @throws ApiError
     */
    public unlinkEntityFromWorkflow(
        workflowGuid: string,
        entityGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/WorkflowInstance/{workflowGuid}/{entityGuid}/UnlinkEntityFromWorkflow',
            path: {
                'workflowGuid': workflowGuid,
                'entityGuid': entityGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get entities that are linked to any workflow sharing the same primary entity as the given workflow.
     * Used by the WorkflowAssociation form element to show selectable entities scoped to the application.
     * @param workflowGuid The current workflow GUID.
     * @param requestBody Optional filter by entity definition types.
     * @returns LinkedEntityDto OK
     * @throws ApiError
     */
    public getRelatedEntitiesForAssociation(
        workflowGuid: string,
        requestBody?: Array<string>,
    ): CancelablePromise<Array<LinkedEntityDto>> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowInstance/{workflowGuid}/GetRelatedEntitiesForAssociation',
            path: {
                'workflowGuid': workflowGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Delete a workflow instance and all its associated form responses and linked entity records.
     * This is a permanent, irreversible operation.
     * @param workflowGuid The workflow GUID.
     * @returns any OK
     * @throws ApiError
     */
    public deleteWorkflowInstance(
        workflowGuid: string,
    ): CancelablePromise<any> {
        return this.httpRequest.request({
            method: 'DELETE',
            url: '/api/WorkflowInstance/{workflowGuid}/DeleteWorkflowInstance',
            path: {
                'workflowGuid': workflowGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all workflows associated with an entity - both workflows created for this entity (primary)
     * and workflows explicitly linked to this entity.
     * @param entityGuid The entity GUID.
     * @returns LinkedWorkflowSummaryDto OK
     * @throws ApiError
     */
    public getLinkedWorkflows(
        entityGuid: string,
    ): CancelablePromise<Array<LinkedWorkflowSummaryDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowInstance/entity/{entityGuid}/GetLinkedWorkflows',
            path: {
                'entityGuid': entityGuid,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Get all workflows associated with an entity - both workflows created for this entity (primary)
     * and workflows explicitly linked to this entity.
     * @param entityGuid The entity GUID.
     * @param includeArchived Whether to include archived workflows.
     * @returns LinkedWorkflowSummaryDto OK
     * @throws ApiError
     */
    public getLinkedWorkflowsWithArchived(
        entityGuid: string,
        includeArchived: boolean = false,
    ): CancelablePromise<Array<LinkedWorkflowSummaryDto>> {
        return this.httpRequest.request({
            method: 'GET',
            url: '/api/WorkflowInstance/entity/{entityGuid}/{includeArchived}/GetLinkedWorkflows',
            path: {
                'entityGuid': entityGuid,
                'includeArchived': includeArchived,
            },
            errors: {
                401: `Unauthorized`,
            },
        });
    }
    /**
     * Create an entity from a completed entity form response within a workflow.
     * The entity definition is determined by the form response's FormDefinitionGuid
     * and the workflow definition's EntityFormsInWorkflowDefinition configuration.
     * @param workflowGuid The workflow GUID.
     * @param formResponseGuid The form response GUID for the entity form.
     * @param requestBody Optional name for the new entity.
     * @returns Entity OK
     * @throws ApiError
     */
    public createEntityFromWorkflowForm(
        workflowGuid: string,
        formResponseGuid: string,
        requestBody?: string,
    ): CancelablePromise<Entity> {
        return this.httpRequest.request({
            method: 'POST',
            url: '/api/WorkflowInstance/{workflowGuid}/{formResponseGuid}/CreateEntityFromWorkflowForm',
            path: {
                'workflowGuid': workflowGuid,
                'formResponseGuid': formResponseGuid,
            },
            body: requestBody,
            mediaType: 'application/json',
            errors: {
                401: `Unauthorized`,
            },
        });
    }
}
